export enum FormFlowFieldNumberTypes {
    integer = "integer",
    decimal = "decimal"
}